<template>
  <div
    id="pageRoot"
    class="backgroundDeaf"
    style="background-color: var(--book-background-color)"
  >
    <img id="bg" class="pageElement" src="/pages/img/intro/svg04bg.svg" />

    <img
      id="zorrito"
      class="pageElement basicItem01"
      src="/pages/img/intro/svg04Zorrito.svg"
    />
    <div
      class="pageElement text-box-a hover-animation-a"
      id="globe01"
      style="background-image: url(/pages/img/intro/svg04Globe01.svg)"
    >
      <p class="textBase" id="textBox01Text">
        YO VIVO EN UNA<br />
        MADRIGUERA
      </p>
    </div>
  </div>
</template>
<style scoped>
#bg {
  position: absolute;
  left: 81px;
  top: 0px;
  z-index: 0;
}
#zorrito {
  position: absolute;
  left: 141px;
  top: 273px;
  z-index: 1;
}
#globe01 {
  position: absolute;
  width: 366px;
  height: 176px;
  left: 487px;
  top: 85px;
  z-index: 1;
}
#textBox01Text {
  position: absolute;
  width: 385px;
  left: -10px;
  top: 30px;
  font-size: 26px;
  line-height: 40px;
  text-align: center;
  color: #fbf8f8;
}
</style>
<script>
export default {
  data() {
    return {
      videos: ["p7/V6.mp4"]
    };
  },
};
</script>